<template>
    <v-dialog v-model="shows" :width="synced ? 720 : 320" persistent>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-bind="{ loading }">
            <v-card-title>
                MES 데이터 싱크
                <v-spacer />
                <v-icon v-bind="{ loading }" @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <template v-if="!synced">
                <v-card-text class="card-text-area">
                    <p>MES 데이터와 싱크를 진행합니다.</p>
                    <p>MES와의 연결 상태에 따라 진행되지 않을 수 있습니다.</p>
                    <p>한 번 싱크된 데이터는 삭제되지 않으며, 신규 등록되는 데이터의 수에 따라 최소 수 초에서 수 분 이상의 시간이 소요됩니다.</p>
                </v-card-text>
                <v-card-actions>
                    <v-btn block v-bind="{ loading }" @click="sync">진행하기</v-btn>
                </v-card-actions>
            </template>
            <template v-else>
                <v-card-text class="card-text-area">
                    <p>MES 데이터 총 {{ summary.totalCount }} 건 중 {{ summary.createdCount }} 건을 생성하였습니다.</p>
                    <template v-if="materials.length">
                        <p>새로 생성된 데이터는 아래 내역을 확인해주세요</p>
                    </template>
                </v-card-text>
                <template v-if="materials.length">
                    <v-divider />
                    <v-data-table v-bind="{ headers, items }" />
                </template>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { initDataTableHeaders } from "@/assets/variables";

export default {
    data: () => ({
        summary: {
            totalCount: 0,
            createdCount: 0,
        },
        materials: [],

        shows: false,
        synced: false,
        loading: false,
    }),
    computed: {
        headers() {
            return initDataTableHeaders([
                { text: "#", value: "index", width: +80, align: "right" },
                { text: "분류", value: "category.name", cellClass: "text-truncate max-width-0", withTitle: true, width: 160 },
                { text: "자재", value: "code", cellClass: "text-truncate max-width-0", withTitle: true },
                { text: "설명", value: "name", cellClass: "text-truncate max-width-0", withTitle: true },
            ]);
        },
        items() {
            return [...this.materials].map((item, index) => ({ ...item, index: index + 1 }));
        },
    },
    methods: {
        init() {
            this.summary = {
                totalCount: 0,
                createdCount: 0,
            };
            this.synced = false;
            this.loading = false;
        },
        async sync() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { summary, materials } = await api.console.manufacturing.materials.postSync();
                this.synced = true;
                this.summary = summary;
                this.materials = materials;
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        shows(shows) {
            if (!shows) {
                if (0 < this.summary.createdCount) this.$emit("search");
                this.init();
            }
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.card-text-area p:last-of-type {
    margin-bottom: 0;
}
</style>